import { Component, Input, OnChanges } from '@angular/core';
@Component({
	selector: 'app-error-message',
	templateUrl: 'error-message.component.html',
	styleUrls: ['error-message.component.scss']
})
export class ErrorMessageComponent implements OnChanges {
	@Input() public key: string;

	public message = '';

	public constructor() {}

	public ngOnChanges(): void {
		if (this.key) {
			this.message = this.key;
		}
	}
}
